<template>
  <div>
      <!-- <v-snackbar v-model="mostrarSnackbar" :timeout="3000" :color="colorSnack"> -->
      <!-- <div class="d-flex justify-space-around">
        <span class="ma-2 font-weight-bold"> {{ mensajeSnack }} </span>
        <v-btn text dark @click="mostrarSnackbar = !mostrarSnackbar"> Cerrar </v-btn>
      </div> -->
        <!-- </v-snackbar> -->

    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex  justify-space-between">
        <v-col cols="12" sm="12" md="3" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/OrdenesDeCompra">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Requisiciones activas</h1>
        </v-col>
      </v-row>
    </v-container>

    

    <v-container fluid class="mt-3 pa-2 white margen">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <span class="text-h5 mx-3">Información.</span>
        </div>
      </div>

      <!-- <v-card :disabled="editar" class="ma-3 pa-3"> -->
      <v-card :disabled="false" class="ma-3 pa-3">
        <!-- SECCION FECHA -->
        <!-- <v-menu
          v-model="modalFecha"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaSeleccionada"
              label="Fecha a entregar"
              prepend-icon="mdi-calendar"
              filled
              light
              readonly
              v-bind="attrs"
              v-on="on"
            >
            </v-text-field>
          </template>
          <v-date-picker
            v-model="fechaSeleccionada"
            @input="modalFecha = false"
            :min="minFecha[0]"
          >
          </v-date-picker>
        </v-menu> -->
        <!-- FIN SECCION FECHA -->

        <v-divider></v-divider>
        <!-- SECCION FECHA -->
        <v-menu
          v-model="modalFecha"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaSeleccionada"
              label="Fecha a entregar"
              prepend-icon="mdi-calendar"
              filled
              light
              readonly
              v-bind="attrs"
              v-on="on"
            >
            </v-text-field>
          </template>
          <v-date-picker
            v-model="fechaSeleccionada"
            @input="modalFecha = false"
            :min="minFecha[0]"
          >
          </v-date-picker>
        </v-menu>
        <!-- FIN SECCION FECHA -->
        <!-- SELECCIÓN DE ALMACÉN -->
        <v-divider></v-divider>
          <div class="d-flex">
          <v-autocomplete
            class="mx-1"
            label="Almacen"
            v-model="almacenSeleccionado"
            :items="almacenes"
            item-text="NOMBRE"
            item-value="NOMBRE"
            return-object
          />
        </div>
        <v-divider></v-divider>
        <!-- FIN SELECCIÓN DE ALMACÉN -->

        <!-- SECCION PRODUCTOS -->
        <div class="my-2">
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <span class="mouse noselect" v-ripple @click="mostrarArticulos=!mostrarArticulos">
            Proveedores
            <v-icon dense light>
              {{ iconoFlecha }}
              </v-icon>
            </span>
          </div>

          <v-alert v-if="cargandoNuevaOrden" class="yellow lighten-3 d-flex justify-center">
            <span class="text--white">Cargando...</span>
          </v-alert>

          <transition name="fade">
            <v-expansion-panels accordion v-if="mostrarArticulos"
             class="elevation-1 justify-start"
             focusable 
             multiple>
             <v-card-title style="width:100%;" class="grey lighten-1">
                <div> Proveedores:
                  <span class="subtitle-1 d-flex" style="display:block; word-break:break-word!important;"> 
                    <!-- <ModalExcel  @EXCEL="archivoExcel"/> -->
                    <!-- <v-btn class="success darken-1 mx-2" small text @click="mostrarModalProductos = true">
                      Agregar Artículo/s
                    </v-btn> -->
                    <!-- <v-dialog v-model="mostrarModalArticulos" max-width="">
                        <ModalAgregarProducto 
                        :infoProyecto="infoProyecto"
                        @cerrarModal="mostrarModalProductos=false"/>
                    </v-dialog>
                   <u>{{ mostrarExcel }}</u> -->
                  </span>
                </div>
                
             </v-card-title>

              <div>
                
              </div>
              <v-expansion-panel v-for="proveedor in proveedores" :key="proveedor.PROVEEDOR_ID">
                  
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex">
                  <v-row>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{proveedor.NOMBRE}}                   </v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold" style="text-align:right;">Articulos a ordenar                            </v-col>
                  </v-row>
                </v-expansion-panel-header>
                
                <!-- <v-expansion-panel-content 
                v-for="articulo in proveedor.ARTICULOS" :key="articulo.ARTICULO_ID" 
                class="mouse borde" 
                v-ripple
                > -->
                <v-expansion-panel-content 
                class="mouse borde"
                >
                    <!-- {{articulosSeleccionados}} -->
                    <v-data-table :id="proveedor.PROVEEDOR_ID"
                    :headers="columnasProyectos"
                    :items="proveedor.ARTICULOS"
                    show-select
                    item-key="REQUISICION_DETALLE_ID"
                    v-model="articulosSeleccionados"
                    item-class="allB"
                    @input="log"
                    hide-default-footer
                    disable-pagination
                    >

                    </v-data-table>
                        <!-- <div class="d-flex justify-space-between">
                            <div style="width:(100/2)%;"> 
                            <div> {{ articulo.NOMBRE }}</div>
                            <div>
                                Cantidad: 
                                {{ parseInt('' + (articulo.CANTIDAD * 100)) / 100 }} 
                            </div>

                            </div> -->
                            <!-- <div style="width:(100/2)%;" class="my-auto"> 
                            <ModalEliminarArticulo
                            :articulo="articulo"
                            @eliminarArticulo="eliminarArticulo(producto.PRODUCTO_ID, articulo.ARTICULO_ID)"/>
                            </div> -->
                        <!-- </div>
                        <div class="d-flex">
                        </div> -->
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </transition>

        </div>
        <!-- FIN SECCION PRODUCTOS -->

        <v-divider></v-divider>

        <div class="d-flex justify-center mb-2">
          <v-btn class="mx-3 colorP darken-1" 
            dark small text :loading="cargandoNuevaOrden" @click="CrearOrden">
              Crear orden
          </v-btn>
        </div>

      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return{
            //Datos para almacenar los proveedores y sus artículos
            proveedores: [],
            proveedoresUnicos:[],
            proveedoresSeleccionados:[],
            articulosSeleccionados: [],
            mostrarArticulos: false,
            mostrarSnackbar: false,
            mensajeSnack: '',
            colorSnack: '',
            cargandoNuevaOrden: false,
            fechaSeleccionada:'',
            modalFecha: false,
            minFecha:"",
            almacenes:[],
            almacenSeleccionado: null,
            columnasProyectos:[
                {text:"Nombre", value:"NOMBRE"},
                {text:"Cantidad", value:"CANTIDAD"}
            ],
        };
    },
    computed: {
        ...mapGetters(["getURLAPI","getUsuario","getFechaActual"]),

        iconoFlecha : function() {
        return this.mostrarArticulos ? "mdi-arrow-up-drop-circle":"mdi-arrow-down-drop-circle"
        },
    },
    methods: {
        async getAlmacenes() {
          this.almacenes = (
            await axios.get(`${this.getURLAPI}/Show/allStorage`)
          ).data;
          console.log(this.almacenes);
        },
        async getProveedores(){
            this.cargandoNuevaOrden = true;
            //let cont = 1;
            try{
                this.proveedores = (await axios.get(`${this.getURLAPI}/Ordenes/getRequisicionesProveedor`)).data;
                console.log(this.proveedores);

                for(const proveedor of this.proveedores){
                    proveedor.ARTICULOS = (
                        await axios.get(`${this.getURLAPI}/Ordenes/getArticulosProveedor/${proveedor.PROVEEDOR_ID}`)
                    ).data
                    // proveedor.ARTICULOS.forEach(element => {
                    //   element.INDEX = proveedor.PROVEEDOR_ID+"-"+proveedor.ARTICULOS.ARTICULO_ID;
                    //   //cont++;
                    // });
                }
                console.log(this.proveedores);
                this.mostrarArticulos = true;
                this.cargandoNuevaOrden = false;
            }
            catch( err ){
                console.log(err);
            }
        },
        snackbar( data ){
        this.mostrarSnackbar = true;
        this.mensajeSnack = data.MSG;
        
        if ( data.STATUS !== "ERROR" ) {
            this.colorSnack = 'success darken-1'
        }
        else{
            this.colorSnack = 'red lighten-1'
        }
        },

        onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        },

        CrearOrden(){
            console.log(this.articulosSeleccionados);
            if(this.fechaSeleccionada != "" && this.articulosSeleccionados.length > 0)
            {
              //Creo los arreglos para cada proveedor
              this.articulosSeleccionados.forEach(element => {
                this.proveedoresSeleccionados.push(element.PROVEEDOR_ID)
              });

              //this.proveedoresUnicos = this.proveedoresSeleccionados.filter(onlyUnique);
              console.log(this.proveedoresUnicos);

              let datosForm = new FormData();
              datosForm.append("PROVEEDOR_ID",this.articulosSeleccionados[0].PROVEEDOR_ID);
              datosForm.append("FECHA",this.articulosSeleccionados[0].FECHA);
              datosForm.append("DESCUENTO_PP", this.articulosSeleccionados[0].DESCUENTO_PP);
              
              datosForm.append("USUARIO_CREADOR",this.getUsuario);
              datosForm.append("ARTICULOS",JSON.stringify(this.articulosSeleccionados));
              datosForm.append("FECHA", this.fechaSeleccionada);
              datosForm.append("ALMACEN_ID", this.almacenSeleccionado.ALMACEN_ID);

              console.log(this.almacenSeleccionado.ALMACEN_ID);
  
  
              axios.post(`${this.getURLAPI}/Ordenes/insertOrden`, datosForm)
              .then( ({data}) =>{
              console.log(data);
              this.$root.vtoast.show({
                  message: data.MSG || "Error",
                  color: data.STATUS == "OK" ? "success darken-1" : "red darken-1",
                  timer: 10000,
                  icon: data.STATUS == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
                });
                if(data.STATUS == "OK")
                {
                    this.$router.push("/OrdenesDeCompra");
                }
              })
              .catch( () => {
                 this.$root.vtoast.show({
                  message: "Error al crear la orden",
                  color: "red darken-1",
                  timer: 10000,
                  icon: "mdi-alert-circle-outline",
                });
              })
            }
            else
            {
              alert("Seleccione la fecha de entrega y/o seleccione al menos un artículo a ordenar.");
            }
        },
        
        log(){
          console.log(this.articulosSeleccionados);
            // for(let i = 0; i<this.articulosSeleccionados.length; i++){
            //     console.log(this.articulosSeleccionados[i]);
            // }
        }
    },

    created() {
        document.title = "Crear orden de compra";
        this.minFecha = this.getFechaActual.split(" ");
        this.getProveedores();
        this.getAlmacenes();
    }
}
</script>

<style>

</style>